import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref, watch, nextTick, onUnmounted, toRefs } from 'vue';
import { commonToolbar } from '@/const/toolbar';
import { uploadObs } from 'hxhy-obs';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme'; ////编辑器主题
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/icons/default/icons';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link'; //超链接
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste'; //粘贴过滤

import 'tinymce/plugins/autoresize';
import '../plugins';
import '../plugins/zh_CN';
import FormulaEdit from '@/components/formula/edit.vue';
import FormulaList from '@/components/formula/list.vue';
/* 变量 */

export default {
  __name: 'inlineEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    tinymceId: {
      type: String,
      default: function _default() {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
      }
    },
    toolbar: {
      type: Array,
      default: function _default() {
        return commonToolbar;
      }
    },
    // 编辑器最小高
    minHeight: {
      type: Number,
      default: 108
    },
    // 编辑器最大高(最小高度三倍)
    maxHeight: {
      type: Number,
      default: 324
    }
  },
  emits: ['update:value', 'editBlur'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var props = __props;
    var _toRefs = toRefs(props),
      value = _toRefs.value,
      tinymceId = _toRefs.tinymceId,
      toolbar = _toRefs.toolbar,
      minHeight = _toRefs.minHeight;
    var tinymceHtml = ref('');
    var uploadRef = ref();
    var fileType = ref('');
    var loading = ref(false);
    var boxId = 'vue-tool-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
    var upload = 'input-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
    var formulaEditVisible = ref(false); //新建公式
    var formulaListVisible = ref(false); //插入公式

    var initConfig = {
      language: 'zh_CN',
      // 指定语言
      selector: "#".concat(tinymceId.value),
      menubar: false,
      // 是否显示 菜单
      branding: false,
      // 是否显示 技术支持文案
      convert_urls: false,
      //关闭此选项，TinyMCE将不会自动处理URL
      paste_data_images: true,
      plugins: 'paste table formatpainter autoresize image',
      statusbar: false,
      // 是否显示 底部状态栏
      auto_focus: false,
      height: 'auto',
      min_height: minHeight.value,
      max_height: minHeight.value * 3,
      content_style: "\n    body { font-family: 'Sans Regular'; }\n    p { margin: 0 0 0px 0; line-height: 1.6; word-break: break-all; }\n    .mce-offscreen-selection video { width:0 !important; }\n    table tbody, tr, td { border: 1px solid gray }\n    table tbody tr td[data-mce-selected] { background-color: #b4d7ffb3; }\n    img{ max-width: 100%;}\n    img[data-mce-selected]{ outline: 3px solid #b4d7ff; }\n    .mce-resizehandle {\n      background-color: #4099ff;\n      border-color: #4099ff;\n      border-style: solid;\n      border-width: 1px;\n      box-sizing: border-box;\n      height: 10px;\n      position: absolute;\n      width: 10px;\n      z-index: 1298\n    }\n    .mce-resize-helper {\n      background: #555;\n      background: rgba(0,0,0,.75);\n      border: 1px;\n      border-radius: 3px;\n      color: #fff;\n      display: none;\n      font-family: sans-serif;\n      font-size: 12px;\n      line-height: 14px;\n      margin: 5px 10px;\n      padding: 5px;\n      position: absolute;\n      white-space: nowrap;\n      z-index: 10002\n    }\n    .mce-clonedresizable {\n      cursor: default;\n      opacity: 0.5;\n      outline: 1px dashed black;\n      position: absolute;\n      z-index: 10001;\n    }\n    img::-moz-selection {\n      background: none;\n    }\n    img::selection {\n      background: none;\n    }\n  ",
      // 内容区样式
      block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;',
      toolbar: toolbar.value,
      object_resizing: true,
      //调整大小控件开关
      resize_img_proportional: false,
      images_upload_url: false,
      image_title: false,
      // 是否开启图片标题设置的选择，这里设置否
      // powerpaste_word_import: 'clean', // 是否保留word粘贴样式  clean | merge
      // paste_as_text: true,
      paste_word_valid_elements: 'table,thead,tbody,tr,th,td',
      images_dataimg_filter: function images_dataimg_filter(img) {
        return img.hasAttribute('internal-blob');
      },
      // 初始化tinymce回调
      setup: function setup(editor) {
        // 自定义图片上传按钮 toolbar
        editor.ui.registry.addButton('customImageButton', {
          icon: 'image',
          tooltip: '上传图片',
          onAction: function onAction() {
            fileType.value = 'image';
            nextTick(function () {
              document.getElementById("".concat(upload)).click();
            });
          }
        });
        // 自定义插入公式icon
        editor.ui.registry.addIcon('formulaTool', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="20" height="20" viewBox="0 0 20 20"><g><g><path d="M10.762888756713867,4.8505972917954105L3.5920997567138673,4.84999942779541L3.586742756713867,4.84999942779541L3.5118147567138673,4.85535162779541L3.509166756713867,4.85563567779541Q3.054048756713867,4.90443882779541,2.895562256713867,5.33946142779541Q2.735837756713867,5.7778814277954105,3.0638367567138673,6.11145942779541L6.710668756713867,9.821029427795409L3.067984756713867,13.43465942779541L3.017149756713867,13.490179427795411L3.014360756713867,13.49360942779541Q2.723757756713867,13.85118942779541,2.9214976567138673,14.273449427795411Q3.1208277567138674,14.69909942779541,3.5920867567138672,14.69909942779541L10.768738756713867,14.69909942779541L10.846238756713868,14.69302942779541L10.849168756713867,14.69268942779541Q11.128938756713866,14.65967942779541,11.316238756713867,14.44923942779541Q11.503528756713868,14.23880942779541,11.503868756713867,13.95708942779541L11.503868756713867,13.95243942779541L11.499148756713867,13.87483942779541L11.498648756713868,13.87061942779541Q11.465638756713867,13.59083942779541,11.255208756713866,13.40354942779541Q11.044768756713868,13.21625942779541,10.762878756713867,13.21591942779541L5.3906887567138675,13.21591942779541L8.281598756713867,10.350809427795411L8.336868756713868,10.288129427795411L8.339588756713868,10.284649427795411Q8.511448756713868,10.06488942779541,8.495838756713868,9.786339427795411Q8.480238756713867,9.50778942779541,8.284768756713866,9.308459427795409L5.359008756713868,6.33261942779541L10.768078756713868,6.33317942779541L10.845708756713867,6.32777942779541L10.849408756713867,6.32733942779541Q11.141148756713868,6.29244942779541,11.329708756713867,6.0670994277954104Q11.518268756713868,5.84175642779541,11.501148756713867,5.54842742779541Q11.484038756713867,5.25509842779541,11.270558756713868,5.05321042779541Q11.057068756713868,4.85132184779541,10.762888756713867,4.8505972917954105ZM15.581328756713868,10.44416942779541L12.040728756713866,10.44416942779541Q11.545628756713867,10.44416942779541,11.545628756713867,10.93925942779541Q11.545628756713867,11.17393942779541,11.675838756713867,11.30414942779541Q11.806048756713867,11.43435942779541,12.040728756713866,11.43435942779541L15.581328756713868,11.43435942779541Q15.803628756713866,11.43435942779541,15.940028756713867,11.29799942779541Q16.076428756713867,11.16163942779541,16.076428756713867,10.93925942779541Q16.076428756713867,10.44416942779541,15.581328756713868,10.44416942779541ZM16.991828756713865,12.50607942779541Q16.833728756713867,12.34793942779541,16.61012875671387,12.34793942779541L14.054028756713867,12.34793942779541Q14.098828756713868,12.24714942779541,14.098628756713866,12.12797942779541Q14.098228756713867,11.90489942779541,13.940428756713867,11.747179427795409Q13.782728756713867,11.58944942779541,13.559628756713867,11.58906942779541Q13.336528756713868,11.58868942779541,13.177928756713866,11.74624942779541L12.417008756713868,12.50714942779541Q12.258848756713867,12.66527942779541,12.258848756713867,12.88893942779541Q12.258848756713867,13.11260942779541,12.417008756713868,13.27073942779541L13.177528756713867,14.03127942779541Q13.335728756713868,14.18942942779541,13.559328756713867,14.18941942779541Q13.783028756713867,14.18942942779541,13.941128756713868,14.03127942779541Q14.099228756713867,13.87313942779541,14.099228756713867,13.64948942779541Q14.099228756713867,13.52913942779541,14.053428756713867,13.42775942779541L16.61012875671387,13.42775942779541Q16.833728756713867,13.42775942779541,16.991828756713865,13.26962942779541Q17.150028756713866,13.11148942779541,17.150028756713866,12.88784942779541Q17.150028756713866,12.66420942779541,16.991828756713865,12.50607942779541ZM11.690648756713868,15.18649942779541Q11.835648756713868,15.33149942779541,12.040728756713866,15.33149942779541L15.581328756713868,15.33149942779541Q15.786428756713867,15.33149942779541,15.931428756713867,15.18649942779541Q16.076428756713867,15.04149942779541,16.076428756713867,14.83645942779541Q16.076428756713867,14.63137942779541,15.931428756713867,14.48636942779541Q15.786428756713867,14.34135942779541,15.581328756713868,14.34135942779541L12.040728756713866,14.34135942779541Q11.835658756713867,14.34135942779541,11.690648756713868,14.48636942779541Q11.545638756713867,14.63137942779541,11.545638756713867,14.83644942779541Q11.545638756713867,15.04149942779541,11.690648756713868,15.18649942779541Z" fill-rule="evenodd" fill="#000000" fill-opacity="1"/></g><g></g></g></svg>');
        // 自定义按钮插入公式toolbar
        editor.ui.registry.addButton('customToolButton', {
          icon: 'formulaTool',
          tooltip: '插入公式',
          onAction: function onAction() {
            console.log(11111);
            formulaListVisible.value = true;
          }
        });
        // 自定义新建公式icon
        editor.ui.registry.addIcon('addFormula', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="20" height="20" viewBox="0 0 20 20"><g><g><path d="M10.96009755859375,5.192293882203125L3.60713055859375,5.191680908203125L3.60177355859375,5.191680908203125L3.52514555859375,5.197154728203125L3.52249755859375,5.197438868203125Q3.05817855859375,5.247228608203125,2.89647785859375,5.691071908203125Q2.73351955859375,6.138369908203125,3.06816455859375,6.478710908203125L6.81030755859375,10.285230908203125L3.07244855859375,13.993280908203126L3.02046055859375,14.050050908203126L3.0176705585937498,14.053490908203125Q2.72119355859375,14.418300908203125,2.92294285859375,14.849120908203124Q3.12630955859375,15.283380908203124,3.6071185585937497,15.283380908203124L10.96594755859375,15.283380908203124L11.04519755859375,15.277180908203125L11.04812755859375,15.276880908203125Q11.33357755859375,15.243180908203126,11.52466755859375,15.028460908203124Q11.71575755859375,14.813760908203125,11.71609755859375,14.526330908203125L11.71610755859375,14.521690908203125L11.71127755859375,14.442340908203125L11.71077755859375,14.438120908203125Q11.67709755859375,14.152670908203126,11.46239755859375,13.961580908203125Q11.24769755859375,13.770490908203126,10.96008755859375,13.770150908203124L5.44215755859375,13.770150908203124L8.41299755859375,10.825820908203125L8.469507558593751,10.761730908203125L8.47223755859375,10.758250908203124Q8.647577558593749,10.534030908203125,8.63165755859375,10.249840908203126Q8.61572755859375,9.965640908203124,8.41630755859375,9.762270908203124L5.40984755859375,6.704350908203125L10.96529755859375,6.704920908203125L11.04467755859375,6.699400908203125L11.04836755859375,6.698960908203125Q11.34602755859375,6.663360908203125,11.53840755859375,6.433450908203125Q11.73077755859375,6.203540908203125,11.71331755859375,5.904263908203125Q11.69585755859375,5.604992908203125,11.47804755859375,5.399012908203125Q11.26023755859375,5.193033118203125,10.96009755859375,5.192293882203125ZM14.90764755859375,13.449600908203125L16.51654755859375,13.449600908203125Q16.77894755859375,13.449580908203124,16.96444755859375,13.264140908203125Q17.14994755859375,13.078670908203126,17.14994755859375,12.816270908203126Q17.14994755859375,12.553910908203125,16.96444755859375,12.368430908203125Q16.77894755859375,12.182950908203125,16.51654755859375,12.182950908203125L14.90764755859375,12.182950908203125L14.90764755859375,10.573790908203126Q14.90764755859375,10.311430908203125,14.72204755859375,10.125920908203124Q14.53654755859375,9.940460908203125,14.27414755859375,9.940460908203125Q14.01184755859375,9.940460908203125,13.82624755859375,10.125920908203124Q13.64064755859375,10.311430908203125,13.64064755859375,10.573790908203126L13.64064755859375,12.182940908203125L12.03183755859375,12.182940908203125Q11.76940755859375,12.182940908203125,11.58388755859375,12.368430908203125Q11.39835755859375,12.553920908203125,11.39835755859375,12.816270908203126Q11.39835755859375,13.078680908203125,11.58388755859375,13.264150908203124Q11.76939755859375,13.449600908203125,12.03183755859375,13.449600908203125L13.64074755859375,13.449600908203125L13.64074755859375,15.058760908203125Q13.64074755859375,15.321180908203125,13.82634755859375,15.506680908203125Q14.01184755859375,15.692080908203126,14.27414755859375,15.692080908203126Q14.53654755859375,15.692080908203126,14.72204755859375,15.506680908203125Q14.90764755859375,15.321180908203125,14.90764755859375,15.058760908203125L14.90764755859375,13.449600908203125Z" fill-rule="evenodd" fill="#000000" fill-opacity="1"/></g><g></g></g></svg>');
        // 自定义按钮新建公式toolbar
        editor.ui.registry.addButton('customFormulaButton', {
          icon: 'addFormula',
          tooltip: '新建公式',
          onAction: function onAction() {
            formulaEditVisible.value = true;
          }
        });
      },
      init_instance_callback: function init_instance_callback(editor) {
        editor.on('focus', function () {
          document.getElementById("".concat(boxId)).querySelector('.tox-editor-header').style.display = 'block';
        });
        editor.on('blur', function () {
          document.getElementById("".concat(boxId)).querySelector('.tox-editor-header').style.display = 'none';
          emit('update:value', tinymceHtml.value);
          console.log(tinymceHtml.value, '----tinymceHtml.value');
          emit('editBlur');
        });
        // 监听 TinyMCE 编辑器的双击事件
        editor.on('DblClick', function (e) {
          console.log(e, e.target.nodeName);
          // 检查是否双击的是图片元素
          if (e.target.nodeName === 'IMG') {
            var imgElement = e.target;
            var type = imgElement.getAttribute('data-type');
            if (type && type === 'formula') formulaEditVisible.value = true;
            // 在这里可以对图片元素进行操作，例如获取自定义属性值
            console.log('image: ' + type);
          }
        });
      },
      paste_preprocess: function () {
        var _paste_preprocess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(plugin, args) {
          var blobFileList, reg;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // console.log(args, '---args')
                blobFileList = args.content.match(/src="blob(.*?)>|src="data:image(?!\/svg)(.*?)>/g) || [];
                blobFileList.forEach(function (v) {
                  return uploadImage(v);
                });
                // 清空数据
                reg = /<img(.*?)src="blob(.*?)>|<img(.*?)src="data:image(?!\/svg)(.*?)>/g;
                if (reg.test(args.content)) {
                  args.content = args.content.replace(reg, '');
                }
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        function paste_preprocess(_x, _x2) {
          return _paste_preprocess.apply(this, arguments);
        }
        return paste_preprocess;
      }()
    };

    // 接口上传图片
    var uploadImage = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dom) {
        var blobsrc, file, resUrl;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              blobsrc = dom && dom.match(/src="(.*?)"/)[1];
              file = dataURLtoFile(blobsrc, "uploadfile.png");
              _context2.n = 1;
              return getUrl(file);
            case 1:
              resUrl = _context2.v;
              handlerSetImageContent(resUrl).then(function (res) {
                tinymce.execCommand('mceInsertContent', false, res);
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function uploadImage(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
    var dataURLtoFile = function dataURLtoFile(dataURL, fileName) {
      // 将 Base64 编码的数据解码为二进制数据
      var byteString = atob(dataURL.split(',')[1]);

      // 创建一个 Uint8Array 用于存储二进制数据
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // 使用 Blob 对象创建 File 对象
      var blob = new Blob([ab], {
        type: 'image/jpeg'
      }); // 根据实际情况调整 MIME 类型
      return new File([blob], fileName, {
        type: 'image/jpeg'
      }); // 根据实际情况调整 MIME 类型和文件名
    };
    // 获取上传url
    var getUrl = function getUrl(file) {
      return new Promise(function (resolve, reject) {
        var accessInfo = JSON.parse(localStorage.getItem('accessInfo'));
        var institutionInfo = JSON.parse(localStorage.getItem('userInfo'));
        var bucketSuffix = ['dev', 'test', 'pre', 'prod'].find(function (v) {
          return location.host.includes(v);
        }) || 'prod';
        var opt = {
          bucketName: bucketSuffix === 'prod' ? 'course-prod' : "zxhj-course-".concat(bucketSuffix),
          file: file,
          fileType: 2,
          userId: accessInfo.content.user_id,
          userName: accessInfo.content.username,
          institutionId: institutionInfo.content.institutionId,
          institutionName: institutionInfo.content.institutionName,
          appCode: 'exercise',
          appName: '习题',
          pageName: 'exerciseAdd',
          btnName: '习题编辑图片上传'
        };
        uploadObs(opt).then(function (res) {
          if (!res.includes('http')) res = "https:".concat(res);
          resolve(res);
        }).catch(function (err) {
          loading.value = false;
        });
      });
    };
    var uploadChange = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var _e$target;
        var file, resUrl;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              loading.value = true;
              file = e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0];
              _context3.n = 1;
              return getUrl(file);
            case 1:
              resUrl = _context3.v;
              document.getElementById("".concat(upload)).value = ''; // 清空上传数据
              handlerSetImageContent(resUrl).then(function (res) {
                tinymce.execCommand('mceInsertContent', false, res);
              });
              loading.value = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function uploadChange(_x4) {
        return _ref3.apply(this, arguments);
      };
    }();
    var handlerSetImageContent = function handlerSetImageContent(src) {
      var img = new Image();
      img.src = src;
      return new Promise(function (resolve, reject) {
        img.onload = function () {
          var nowWidth = 0;
          var nowHeight = 0;
          var rito = img.width / img.height;
          rito >= 1 ? nowWidth = 360 : nowHeight = 90;
          var resData = {
            nowWidth: nowWidth,
            nowHeight: nowHeight
          };
          resolve(resData);
        };
        img.onerror = function (e) {
          reject(e);
        };
      }).then(function (res) {
        var nowWidth = res.nowWidth,
          nowHeight = res.nowHeight;
        var imageSrc = '';
        if (nowWidth) {
          imageSrc = "<img src=\"".concat(src, "\" width=\"").concat(nowWidth, "\" style=\"object-fit:cover\" />");
        } else if (nowHeight) {
          imageSrc = "<img src=\"".concat(src, "\" height=\"").concat(nowHeight, "\" style=\"object-fit:cover\"/>");
        }
        return imageSrc;
      }).catch(function (err) {
        console.error(err);
      });
    };
    //
    var getFormulaInfo = function getFormulaInfo(element) {
      console.log('getFormulaInfo', element);
      formulaEditVisible.value = false;
      formulaListVisible.value = false;
      var imageSrc = "<img src=\"".concat(element.url, "\" data-type=\"formula\" data-latex=\"").concat(element.latex, "\" data-name=\"").concat(element.name, "\" style=\"object-fit:cover\"/>");
      tinymce.execCommand('mceInsertContent', false, imageSrc);

      // tinymce.activeEditor.insertContent(imageSrc);
      // // 创建图片元素
      // var img = document.createElement('img');
      // img.src = url;
      // img.setAttribute('data-type', 'formula');

      // // 插入图片到编辑器中
      // tinymce.activeEditor.selection.setNode(img);
    };
    var trimWirisValue = function trimWirisValue(content) {
      return content && content.replace(/Wirisformula/g, '');
    };

    /* 监听 */
    watch(tinymceHtml, function (val) {
      console.log(val, '----val');
      emit('update:value', val);
    });
    watch(value, function (val) {
      var newValue = '';
      if (val && val.includes('Wirisformula')) {
        newValue = trimWirisValue(val);
      }
      tinymceHtml.value = newValue || val;
    }, {
      immediate: true
    });

    /* 钩子 */
    onMounted(function () {
      tinymce.init({});
    });
    onUnmounted(function () {
      if (tinymce.get(tinymceId.value)) {
        tinymce.get(tinymceId.value).destroy();
      }
    });
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", {
        class: "tinymce",
        id: boxId
      }, [_createVNode(_unref(Editor), {
        id: _unref(tinymceId),
        modelValue: tinymceHtml.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return tinymceHtml.value = $event;
        }),
        init: initConfig,
        class: "editor-box"
      }, null, 8, ["id", "modelValue"]), _withDirectives(_createElementVNode("input", {
        ref_key: "uploadRef",
        ref: uploadRef,
        id: upload,
        type: "file",
        accept: "image/*",
        onChange: uploadChange
      }, null, 544), [[_vShow, false]]), _createVNode(_component_t_loading, {
        loading: loading.value,
        text: "加载中...",
        fullscreen: ""
      }, null, 8, ["loading"]), formulaEditVisible.value ? (_openBlock(), _createBlock(FormulaEdit, {
        key: 0,
        formulaEditVisible: formulaEditVisible.value,
        "onUpdate:formulaEditVisible": _cache[1] || (_cache[1] = function ($event) {
          return formulaEditVisible.value = $event;
        }),
        onGetFormulaInfo: getFormulaInfo
      }, null, 8, ["formulaEditVisible"])) : _createCommentVNode("", true), formulaListVisible.value ? (_openBlock(), _createBlock(FormulaList, {
        key: 1,
        formulaListVisible: formulaListVisible.value,
        "onUpdate:formulaListVisible": _cache[2] || (_cache[2] = function ($event) {
          return formulaListVisible.value = $event;
        }),
        onGetFormulaInfo: getFormulaInfo
      }, null, 8, ["formulaListVisible"])) : _createCommentVNode("", true)]);
    };
  }
};